var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"background"}),_c('router-view',{key:_vm.$route.path}),_c('notifications',{attrs:{"position":"bottom right"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }